"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _loginBg = _interopRequireDefault(require("@assets/login-bg.jpg"));
var _BackLinkRow = _interopRequireDefault(require("../components/auth/BackLinkRow"));
var _LoginHandoff = _interopRequireDefault(require("../components/auth/LoginHandoff"));
var _useLoginHandoff2 = require("../hooks/use-login-handoff");
var _AuthContext = require("../context/AuthContext");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Container = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    width: 100%;\n    background-color: white;\n    background-image: url(", ");\n    background-size: cover;\n    background-position: center;\n    overflow-y: auto;\n    box-sizing: border-box;\n"])), _loginBg.default);
var Content = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 32px 48px;\n"])));
function SigningInPage(_ref) {
  var onBack = _ref.onBack,
    _ref$backLabel = _ref.backLabel,
    backLabel = _ref$backLabel === void 0 ? "Back" : _ref$backLabel;
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    loginWithKey = _useAuthInfo.loginWithKey;
  var _useLoginHandoff = (0, _useLoginHandoff2.useLoginHandoff)({
      onKey: loginWithKey
    }),
    phase = _useLoginHandoff.phase,
    retry = _useLoginHandoff.retry;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "SigningInPage",
    "data-sentry-source-file": "SigningInPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BackLinkRow.default, {
      label: backLabel,
      onClick: onBack,
      "data-sentry-element": "BackLinkRow",
      "data-sentry-source-file": "SigningInPage.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
      "data-sentry-element": "Content",
      "data-sentry-source-file": "SigningInPage.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginHandoff.default, {
        phase: phase,
        onRetry: retry,
        "data-sentry-element": "LoginHandoff",
        "data-sentry-source-file": "SigningInPage.tsx"
      })
    })]
  });
}
var _default = exports.default = SigningInPage;